import { render } from "./UserManagmentPage.vue?vue&type=template&id=b30f0c36&lang=html"
import script from "./UserManagmentPage.vue?vue&type=script&lang=js"
export * from "./UserManagmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__